import { render, staticRenderFns } from "./IconSvgADAPhysicianPortal.vue?vue&type=template&id=079d63e6&scoped=true&"
import script from "./IconSvgADAPhysicianPortal.vue?vue&type=script&lang=js&"
export * from "./IconSvgADAPhysicianPortal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "079d63e6",
  null
  
)

export default component.exports